import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SignalService {

  private readonly _player_compass = signal<string>("home");

  readonly player_compass = this._player_compass.asReadonly();

  private readonly _header_language = signal<boolean>(false);

  readonly header_language = this._header_language.asReadonly();

  private readonly _modal_type = signal<string>("talk");

  readonly modal_type = this._modal_type.asReadonly();

  private readonly _frm_loading = signal<boolean>(false);

  readonly frm_loading = this._frm_loading.asReadonly();

  private readonly _lock = signal<boolean>(true);

  readonly lock = this._lock.asReadonly();

  private readonly _full = signal<boolean>(false);

  readonly full = this._full.asReadonly();

  setValue(p_key:string, p_val:any):void {

      switch(p_key) {
        case "compass":
          this._player_compass.set(p_val); 
          break;
        
        case "header-language":
          let newv = !this._header_language();
          this._header_language.set(newv);
          break;

        case "modal-type":
          this._modal_type.set(p_val); 
          break;

        case "loading":
          let newv2 = !this._frm_loading();
          this._frm_loading.set(newv2); 
          break;

        case "lock":
          let newv3 = !this._lock();
          this._lock.set(newv3);
          break;

        case "full":
          let newv4 = !this._full();
          this._full.set(newv4);
          break;
      }

  }
  
}
